import { Box } from "@chakra-ui/layout";
import Container from "components/Container";
import PageHeader from "components/Page/PageHeader";
import NewTable from "components/NewTable";
import useListagemImpostos from "../../hooks/useListagemImpostos";
import HeaderTable from "components/Page/HeaderTable";
import ModalCadastrarImposto from "./ModalCadastrarImposto/index";
import { useState, useEffect } from "react";
import { useListarImpostos } from "core/features/Imposto/hooks/useListarImpostos";
import useFiltroImpostos from "./../../hooks/useFiltroImpostos";
import { useLoading } from "components/GlobalLoading/index";
import useExcluirImposto from "core/features/Imposto/hooks/useDeleteImposto";
import { showConfirm } from "infra/helpers/alerta";
import { PermissaoEnum } from "core/resources/enums/permissao";

export default function ListarImpostos() {
  const { filtro, onChangeFiltro } = useFiltroImpostos();
  const columns = useListagemImpostos();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { data, isLoading, isFetching, refetch } = useListarImpostos(filtro);
  const [idImposto, setIdImposto] = useState<string | undefined>();
  const { mutate: excluirImposto, isLoading: isLoadingExcluir } =
    useExcluirImposto();

  useEffect(() => {
    if (idImposto) {
      setIsOpenModal(true);
    }
  }, [idImposto]);

  useEffect(() => {
    if (!isOpenModal) {
      setIdImposto(undefined);
    }
  }, [isOpenModal]);

  useLoading(isLoading || isLoadingExcluir);
  return (
    <>
      <Container>
        <PageHeader
          title={"Impostos"}
          titleButton="Cadastrar novo"
          onClick={() => setIsOpenModal(true)}
          permissions={PermissaoEnum.Backoffice.Financeiro.Impostos.Criar}
        />

        <Box mt="32px">
          <NewTable
            title={() => (
              <HeaderTable
                value={filtro.search || ""}
                onSearch={(v) => onChangeFiltro({ search: v })}
              />
            )}
            loading={isLoading || isFetching}
            columns={columns}
            dataSource={data?.items ?? []}
            actions={[
              {
                title: "Editar",
                permission: PermissaoEnum.Backoffice.Financeiro.Impostos.Editar,
                onClick: (v) => setIdImposto(v.id),
              },
              {
                title: "Excluir",
                permission:
                  PermissaoEnum.Backoffice.Financeiro.Impostos.Excluir,
                onClick: (v) => {
                  showConfirm().then(({ isConfirmed }) => {
                    if (isConfirmed) {
                      excluirImposto(v.id, {
                        onSuccess: () => refetch(),
                      });
                    }
                  });
                },
              },
            ]}
            customPagination={{
              currentPage: data?.meta.currentPage ?? 0,
              totalItems: data?.meta.totalItems ?? 0,
              itemsPerPage: data?.meta.itemsPerPage ?? 0,
              onChangePage: (p) => onChangeFiltro?.({ page: p }),
            }}
            // customSelectedRows={{
            //   handler: setSelecteds,
            //   selecteds,
            //   actions: [],
            // }}
          />
        </Box>
      </Container>
      {isOpenModal ? (
        <ModalCadastrarImposto
          onClose={() => setIsOpenModal(false)}
          open={isOpenModal}
          id={idImposto}
          refetchList={refetch}
        />
      ) : null}
    </>
  );
}
